<h1 class="visually-hidden">{{ 'orders.orderDetails' | transloco }}</h1>
@if (!isLoadingOrder) {
  <div class="flex-container">
    <div class="flex-item">
      <div class="padding-sides-15">
        <app-order-details [order]="order" [uboTreeNode]="uboTreeNode" [uiConfiguration]="uiConfiguration" [loading]="isLoadingOrder">
        </app-order-details>
      </div>
    </div>
    <div class="flex-item-fixed-size padding-top margin-right-15 order-fees-sticky">
      @if (showOrderFeeSummary) {
        <div>
          <app-order-fees></app-order-fees>
          <br />
        </div>
      }
      @if (shouldShowBundlesGrid()) {
        <div>
          <app-order-bundles></app-order-bundles>
          <br/>
        </div>
      }
      @if (!showOrderFeeSummary) {
        <div class="padding-top-80"></div>
      }
      <mat-card>
        <mat-card-content>
          @if (showPrintButton()) {
            <div class="button-container">
              <button mat-flat-button color="primary" class="flex-item-right-align"
                (click)="print()"><mat-icon>print</mat-icon> {{ 'orders.print' | transloco }}</button>
            </div>
          }
          @if(hubReportID) {
            @if (showHubReportButton()) {
              <div class="button-container">
                <button mat-flat-button color="primary" class="flex-item-right-align"
                  (click)="onHubReportClick()"><mat-icon>graph_5</mat-icon>{{ 'common.labels.hubReportManagement' | transloco }}</button>
              </div>
            }
          }
          <div class="button-container">
            <button mat-flat-button color="primary" class="flex-item-right-align"
            (click)="openOrderHistory()">{{ 'orders.history' | transloco }}</button>
          </div>
          <div class="button-container">
            <button mat-flat-button color="primary" class="flex-item-right-align"
            (click)="openValidationLogs()">{{ 'common.labels.validationLogs' | transloco }}</button>
          </div>
          <div class="button-container">
            <button mat-flat-button color="primary" class="flex-item-right-align"
              matBadge="{{messageCount()}}" matBadgeColor="warn"
            (click)="openOrderMessages()">{{ 'common.labels.messages' | transloco }}</button>
          </div>
          @if (showBundlesButton()) {
            <div class="button-container">
              <button mat-flat-button color="primary" class="flex-item-right-align"
              (click)="addToBundle()">{{ 'orders.addToBundle2' | transloco }}</button>
            </div>
          }
        </mat-card-content>
      </mat-card>
      <br />
      @if (isActionable()) {
        <app-actions
        [order]="order" [uiConfiguration]="uiConfiguration.actionUIConfiguration!" [uboTreeNode]="uboTreeNode" [downstreamShareholderHasUbo]="downstreamShareholderHasUbo"></app-actions>
      }
    </div>
  </div>
}

<!-- Spinner (replaces everything and waits until all requests have completed to show anything) -->
@if (isLoadingOrder) {
  <div class="loading-spinner-overlay">
  </div>
}
<!-- End of spinner -->